module.exports = __webpack_public_path__ + "static/media/Team-invoice-pic-4.15bdef05.png";